/* eslint-disable react/no-multi-comp */
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { toRoman } from 'helpers'


export const RESERVE_QUEUE = (counter) => {
    return (
        <FormattedMessage
            id='building_tooltip.reserve_queue'
            defaultMessage={'Резервов в подготовке: {counter}'}
            values={{
                counter,
            }}
        />
    )
}

export const RESERVE_QUEUE_END = (date) => {
    return (
        <FormattedMessage
            id='building_tooltip.reserve_queue_end'
            defaultMessage={'Reserves of all levels will be ready: {date}'}
            values={{
                date,
            }}
        />
    )
}

export const UPGRADE_AVAILABLE = (
    <FormattedMessage
        id='building_tooltip.upgrade_available'
        defaultMessage={'Готово к модернизации'}
    />
)

export const AVAILABLE_RESERVES = (levels) => {
    return (
        <FormattedMessage
            id='building_tooltip.available_reserves'
            defaultMessage={'Reserves can be prepared: {levels}'}
            values={{
                levels,
            }}
        />
    )
}

export const BUILDING_LEVEL = (level) => {
    return (
        <FormattedMessage
            id='building_tooltip.building_level'
            defaultMessage='Building Level {level}'
            values={{ level: toRoman(level) }}
        />
    )
}



// WEBPACK FOOTER //
// ./components/BuildingTooltip/constants.jsx